import { cn } from "@/lib/utils";
import { Icon, type IconName } from "./icon";

export interface CheckCardProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  icon?: IconName;
  label: string;
  sub?: string;
}

export function CheckCard({ checked, onChange, icon, label, sub }: CheckCardProps) {
  return (
    <button
      type="button"
      className={cn("check-card", checked && "checked")}
      onClick={() => onChange(!checked)}
    >
      <span className="check-box">{checked && <Icon name="check" size={13} stroke={2.5} />}</span>
      {icon && <Icon name={icon} size={18} className="check-card-icon" />}
      <span className="check-card-text">
        <span className="check-card-label">{label}</span>
        {sub && <span className="check-card-sub">{sub}</span>}
      </span>
    </button>
  );
}
